import z from "zod";
const optionalDecimal = z.coerce.number().nullable().optional();
export const GestaoRecebimentoEpiSchema = z.object({
  idGestaoEpi: z.coerce.number({
    required_error: "Este campo deve ser preenchido!",
  }),
  ca: z.string().nonempty("Este campo deve ser preenchido!"),
  quantidade: z.coerce.number().nullable().default(null),
  idFornecedor: z.coerce.number().nullable().default(null),
  dataRecebimento: z.coerce.date().nullable().default(null),
  dataValidade: z.coerce.date().nullable().default(null),
  idCentroCusto: z.coerce.number().nullable().default(null),
  marca: z.coerce.string().nullable().default(null),
  notaFiscal: z.coerce.string().nullable().default(null),
  nomeNotaFiscal: z.string().nullable().optional(),
  ArquivoNotaFiscal: z.instanceof(File).nullable().optional(),
  ValorUnitario: optionalDecimal,
  ValorTotal: optionalDecimal,

  //Extra
  especificacao: z.string().optional().nullable(),
  downloadNotaFiscal: z.string().nullable().optional(),
  limparArquivoNotaFiscal: z.boolean().default(false),
});

export type GestaoRecebimentoEpiForm = z.infer<
  typeof GestaoRecebimentoEpiSchema
>;
